import React from 'react';
import { comparisonData } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ProductComparison = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-black text-slate-900 uppercase tracking-tight">Compare Mowers</h2>
          <p className="text-slate-500 mt-2">Find the right deck for your turf.</p>
        </div>

        <div className="bg-white shadow-xl border border-gray-200 rounded-sm overflow-hidden">
          <div className="grid grid-cols-3 bg-slate-900 text-white">
            <div className="p-4 font-bold uppercase tracking-wider text-sm flex items-center text-gray-400">Features</div>
            <div className="p-4 border-l border-slate-700 text-center">
              <span className="block text-lime-400 font-bold uppercase mb-1">Pro Series</span>
              <span className="font-black text-lg">40V Brushless</span>
            </div>
            <div className="p-4 border-l border-slate-700 text-center">
              <span className="block text-gray-400 font-bold uppercase mb-1">Standard</span>
              <span className="font-black text-lg">20V Compact</span>
            </div>
          </div>

          <div className="divide-y divide-gray-200">
            {comparisonData.map((row, idx) => (
              <div key={idx} className="grid grid-cols-3 hover:bg-gray-50 transition-colors">
                <div className="p-4 text-sm font-bold text-slate-700 bg-gray-50 flex items-center">
                  {row.feature}
                </div>
                <div className="p-4 text-center text-slate-600 border-l border-gray-200 flex items-center justify-center font-medium">
                  {row.modelA}
                </div>
                <div className="p-4 text-center text-slate-600 border-l border-gray-200 flex items-center justify-center font-medium">
                  {row.modelB}
                </div>
              </div>
            ))}
          </div>
          
          <div className="grid grid-cols-3 bg-gray-100 p-4">
            <div></div>
            <div className="text-center border-l border-transparent px-2">
              <button className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-2 uppercase text-sm rounded-sm">View Pro</button>
            </div>
            <div className="text-center border-l border-transparent px-2">
              <button className="w-full bg-slate-800 hover:bg-slate-900 text-white font-bold py-2 uppercase text-sm rounded-sm">View Standard</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductComparison;